import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import UsersPage from './pages/UsersPage';
import OrdersPage from './pages/OrdersPage';
import InventoryPage from './pages/InventoryPage';
import ProductsPage from './pages/ProductsPage';
import ShopsPage from './pages/ShopsPage';
import SyncPage from './pages/SyncPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import NotFoundPage from './pages/NotFoundPage';
import PurchaseOrdersPage from './pages/PurchaseOrdersPage';
import WMSPage from './pages/WMSPage';
import AutomationPage from './pages/AutomationPage';
import ShippingLabelsPage from './pages/ShippingLabelsPage';
import DropshipPage from './pages/DropshipPage';
import AmazonToRakutenPage from './pages/AmazonToRakutenPage';
import ProductFiltersPage from './pages/ProductFiltersPage';
import PricingSettingsPage from './pages/PricingSettingsPage';

// 認証必須ルートのラッパー
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

// 管理者専用ルート
function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  if (user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      {/* 認証不要ルート */}
      <Route path="/login" element={<LoginPage />} />

      {/* 認証必須ルート */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="change-password" element={<ChangePasswordPage />} />
        
        {/* 業務機能 */}
        <Route path="orders" element={<OrdersPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="shops" element={<ShopsPage />} />
        <Route path="sync" element={<SyncPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        
        {/* 追加機能 */}
        <Route path="purchase-orders" element={<PurchaseOrdersPage />} />
        <Route path="wms" element={<WMSPage />} />
        <Route path="automation" element={<AutomationPage />} />
        <Route path="shipping-labels" element={<ShippingLabelsPage />} />
        <Route path="dropship" element={<DropshipPage />} />
        <Route path="amazon-to-rakuten" element={<AmazonToRakutenPage />} />
        <Route path="product-filters" element={<ProductFiltersPage />} />
        <Route path="pricing-settings" element={<PricingSettingsPage />} />
        
        {/* 管理者専用 */}
        <Route
          path="admin/users"
          element={
            <AdminRoute>
              <UsersPage />
            </AdminRoute>
          }
        />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;

